import Aboutcommunity from "./aboutcommunity";
import Goals from "./goals";
import Together from "./together";
import Vission from "./vission";
import "./aboutus.scss";
import Faces from "./faces";
import { Link } from "react-router-dom";
import forward from "../../asserts/images/forward.svg";

const Aboutus = () => {
  return (
    <div className="row ">
      <div className="about-box">
        <p className="path">
          <Link to="/home">Home</Link> <img src={forward} className="pb-1" />
          About Us
        </p>
        <h1 className="col-lg-8 col-md-12 about-heading">
          Together, We Can Make a Difference Join Pagirndhunn.
        </h1>
      </div>
      <div>
        <Aboutcommunity></Aboutcommunity>
        <Vission></Vission>
        <Together></Together>
        <Goals></Goals>
        <Faces></Faces>
      </div>
    </div>
  );
};
export default Aboutus;
